export default __webpack_public_path__ + "static/media/react.73dbb5bc.png";